import { ComponentType } from "react"
import { JobPostingMessagingCard } from "./JobPostingMessagingCard"
import { Attachment, AttachmentProps, DefaultStreamChatGenerics } from "stream-chat-react"

export const AttachmentRenderer: ComponentType<AttachmentProps<DefaultStreamChatGenerics>> | undefined = props => {
  if (props.attachments[0].type === "job_posting" && props.attachments[0].id) {
    return <JobPostingMessagingCard jobId={props.attachments[0].id} />
  }
  return <Attachment {...props} />
}
